import React, { useState } from 'react';
import RowTablaMovimientosSinConfirmar from './RowTablaMovimientosSinConfirmar';
 
const TablaBodyMovimientosSinConfirmar = (props) => {

    const { MovimientosSinConfirmar } = props;

    return ( 
            <table className="width100 noBorder saldosSinConfirmarScroll">
                {MovimientosSinConfirmar.movimientosSinConfirmar && MovimientosSinConfirmar.movimientosSinConfirmar.length > 0
                    ?
                    MovimientosSinConfirmar.movimientosSinConfirmar.map((movimiento, index) => { return <RowTablaMovimientosSinConfirmar index={index} movimientosSinConfirmar={movimiento} /> })
                    :
                    <tr className='BLock Personeria paddingLeftXS paddingTopBottom'>
                        <td colSpan="3">Sin Movimientos</td>
                    </tr>
                }
            </table>
        );
      
}

export default TablaBodyMovimientosSinConfirmar;